import './Card.css'
import { Link } from 'react-router-dom';

function Card({ name, img, link}) {
    return (
        <>
            <div class="card">
                <div class="card-image"><img src={img} alt="" /></div>
                <div class="heading">{name}</div>
                <Link className='btn' to={link}>Посмотреть</Link>
            </div>
        </>
    );
}

export default Card;